import { useNavigate } from "react-router-dom";
import ReactDataTable from "../../Components/ReactDataTable";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import { Box, List, Stack, Button, ButtonGroup, Grid } from "@mui/material";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ResponsiveDialog from "../../Components/DialogBox";
import AddUser from "./AddUser";

import AddExistingUser from "./AddExistingUser";
import {
  getEditorDataAction,
  removeEditorDataAction,
} from "../../Redux/Actions/AuthActions";
const UserPermission = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, editorList, totalCount,add_editor} = useSelector(
    (state) => state.Auth
  );
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [open, setOpen] = useState(false);
  const [existingOpen, setExistingOpen] = useState(false);
  const [itemId, setItemId] = useState();
  const [isVisibleModal, setIsVisibleModal] = useState(false);

  let data;
  
  if (editorList?.length) {
    data = editorList?.map((e) => e);
  }

  const [navigateUrl, setNavigateUrl] = useState("/setting/");
  const { setMsgConfig } = useErrorHandler();

  const onTableChange = (filter) => {
    const searchPayload = {
      key: filterText || "",
      perPage: filter?.perpage || 10,
      page: filter?.page || 1,
      sortBy: filter?.sortBy || "id",
      sortDirection: filter?.direction || "DESC",
    };
    dispatch(getEditorDataAction(searchPayload));
  };
  const goBack = () => {
    navigate("/settings");
  };

  useEffect(() => {
    onTableChange();
  }, [filterText, open]);


  useEffect((filter) => {
    if(add_editor){
    const searchPayload = {
      key: filterText || "",
      perPage: filter?.perpage || 10,
      page: filter?.page || 1,
      sortBy: filter?.sortBy || "id",
      sortDirection: filter?.direction || "DESC",
    };
      
    dispatch(getEditorDataAction(searchPayload));}
  }, [add_editor]);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search user by name"
      />
    );
  }, [filterText, resetPaginationToggle]);

  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item.id);
  };

  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };
    dispatch(removeEditorDataAction(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Editor SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  const columns = [
    {
      name: "USER NAME",
      sortField: "email",
      sortable: true,
      selector: (row) => row.email,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.email}</span>
          </span>
        );
      },
    },
    {
      name: "CREATED DATE",
      sortField: "created_at",
      selector: (row) => row.created_at,
      sortable: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.created_at
                ? moment(row.created_at).format("DD/MM/YYYY")
                : "N/A"}{" "}
            </span>
          </span>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        return (
          <>
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row}
                isEditMode={true}
              />
            </span>
          </>
        );
      },
    },
  ];
  return (
    <>
      <HelmetReact name="User Permission" />
      <ResponsiveDialog
        dtype="confirm"
        open={isVisibleModal}
        header="Are you sure you want to delete this User?"
        onConfirm={() => handleConfirm()}
        onClose={() => setIsVisibleModal(false)}
      ></ResponsiveDialog>
      <Box className="d-details-box">
        <Grid container spacing={1}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Button onClick={() => goBack()} className="back-btn">
              <ArrowBackIosIcon
                size="large"
                edge="start"
                aria-label="menu"
                sx={{
                  mr: 2,
                  color: "grey",
                  flexGrow: 0,
                  cursor: "pointer",
                  mb: 1,
                }}
              />
            </Button>
          </Grid>
        </Grid>

        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
              ml: 2,
            }}
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          >
            ADD USER
          </Button>
        </Box>
        <ReactDataTable
          columns={columns}
          items={data}
          onChange={onTableChange}
          paginationTotalRows={totalCount}
          isLoading={loading}
          navigateUrl={navigateUrl}
          isShowSearch={true}
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
        />
      </Box>
      {open && <AddUser open={open} setOpen={setOpen} />}
      {existingOpen && (
        <AddExistingUser open={existingOpen} setOpen={setExistingOpen} />
      )}
    </>
  );
};

export default UserPermission;
